module.exports = __webpack_public_path__ + "img/rotation.7c3f0ed5.svg";